import React from "react";
import Project from "../Project";

function SelectedWork() {
    let projectOne = {
        projectName: "Pawfect Ecom",
        projectImage: "/Images/ecombg.png",
        overview:
            "An E-commerce store selling cat beds. Fullstack with React, Tailwind, SQL, Node and Azure.",
        github: "https://github.com/jack-king1/244001-Jack-Ecommerce",
        routeURL: "pawfectecom",
    };

    let projectTwo = {
        projectName: "Trivia Night",
        projectImage: "/Images/trivia.png",
        overview:
            "A 1 to 4 Player Trivia Networked Game utilising Trivia API, Socket.Io, React and Tailwind.",
        github: "https://github.com/jack-king1/TriviaNightMulti",
        routeURL: "/trivianight",
    };

    let projectThree = {
        projectName: "Pomadoro Timer (In progress)",
        projectImage: "/Images/pomodoro.png",
        overview:
            "A modern pomodoro timer web app utilising React, Tailwind, Pexels API, SQL, Google OAuth.",
        github: "https://github.com/jack-king1/RelaxingPomodoro",
        routeURL: "/pomodoro",
    };

    return (
        <div className="flex flex-col mt-4 font-sourcecodepro">
            <div className="font-bold text-xl mb-4">Selected work</div>
            <div className="flex flex-col gap-14">
                <Project project={projectOne} />
                <Project project={projectTwo} />
                <Project project={projectThree} />
            </div>
        </div>
    );
}

export default SelectedWork;
